import { render } from "./Sweep.vue?vue&type=template&id=32c60b7a&scoped=true"
import script from "./Sweep.vue?vue&type=script&lang=js"
export * from "./Sweep.vue?vue&type=script&lang=js"

import "./Sweep.vue?vue&type=style&index=0&id=32c60b7a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c60b7a"]])

export default __exports__